import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IconTypes } from '@shared/v2';
import { SdvorIconComponent } from '../../icon';
import { SdvorLoaderComponent } from '../../loader';

@Component({
  selector: 'sd-input-search-modal',
  imports: [ReactiveFormsModule, SdvorLoaderComponent, SdvorIconComponent],
  templateUrl: './input-search-modal.component.html',
  styleUrls: ['./input-search-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorInputSearchModalComponent {
  iconTypes = IconTypes;

  @Input() isLoading: boolean;
  @Input() placeholder: string;
  @Input() inputControl: FormControl;

  @Output() clear = new EventEmitter<void>();
  @Output() enterSearchInput = new EventEmitter<void>();

  @ViewChild('inputModalSearch', { read: ElementRef }) inputModalSearchRef: ElementRef<HTMLInputElement>;

  onInputFocus(): void {
    this.inputModalSearchRef.nativeElement.classList.add('focused');
  }

  onInputBlur(): void {
    this.inputModalSearchRef.nativeElement.classList.remove('focused');
  }
}
